import { Upload, WithMongooseProps } from '@runelab/odin-common'
import { GetValues } from 'types/index'

export type SettingPortalSchema = {
  title: string
  description: string
  authMode?: AuthMode
  helpPopupVisible?: boolean
}

export type SettingBackofficeSchema = {
  metaTitle: string
  metaDescription: string
}

export type SettingOperatorSchema = {
  numberOfQuestionsBeforeAskTicketOpen: number
  welcomeMessage: string
  offlineMessage: string
}

export const AuthModeEnum = {
  External: 'external',
  Full: 'full',
  NoLogin: 'noLogin',
} as const

export type AuthMode = GetValues<typeof AuthModeEnum>

export const ThemeEnum = {
  Light: 'light',
  Dark: 'dark',
  Auto: 'auto',
} as const

export type Theme = GetValues<typeof ThemeEnum>

export const ThemeFontEnum = {
  Geist: 'geist',
  Inter: 'inter',
  Figtree: 'figtree',
  Manrope: 'manrope',
  System: 'system',
} as const

export type ThemeFont = GetValues<typeof ThemeFontEnum>

export type Setting = WithMongooseProps<{
  primaryColor: string
  secondaryColor: string
  favicon: Upload
  logo: Upload
  portal: SettingPortalSchema
  backoffice: SettingBackofficeSchema
  operatorSettings?: SettingOperatorSchema
  isPortalHidden: boolean
  reminderTicketUser?: number
  reminderTicketOperator?: number
  theme?: Theme
  themeRadius?: string
  /** Sans font from the curated self-hosted set (see THEME_FONTS in ThemeProviders). Theme editor, fase 7. */
  themeFont?: ThemeFont
  privacyPolicyLink?: string
  cookiePolicyLink?: string
  cookieBannerEnabled?: boolean
  showWidgetExpandButton?: boolean
}>
